import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Clock, X } from "lucide-react";
import { Button } from "./ui/button";
import { useAuth } from "../context/AuthContext";

const copy = (d) =>
  d <= 1
    ? "Last day of your free trial — subscribe today or your saved projects will be removed and your account closed when it ends."
    : `${d} days left on your free trial. Subscribe to keep your saved projects — unsubscribed trial accounts are closed when the trial ends.`;

export function TrialBanner() {
  const { isTrial, trialDaysLeft } = useAuth();
  const navigate = useNavigate();
  const key = `fb_trial_banner_dismissed_${trialDaysLeft}`;
  const [, setTick] = useState(0);
  const hidden = localStorage.getItem(key) === "1";

  if (!isTrial || trialDaysLeft > 3 || trialDaysLeft < 1 || hidden) return null;

  const dismiss = () => { localStorage.setItem(key, "1"); setTick((t) => t + 1); };
  const urgent = trialDaysLeft <= 1;

  return (
    <div className={urgent ? "bg-destructive text-destructive-foreground" : "bg-amber-50 text-amber-900 border-b border-amber-200"} data-testid="trial-reminder-banner">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-3 px-4 py-2.5 text-sm sm:px-6 lg:px-8">
        <Clock className="h-4 w-4 shrink-0" />
        <p className="flex-1" data-testid="trial-reminder-text">{copy(trialDaysLeft)}</p>
        <Button size="sm" variant={urgent ? "secondary" : "default"} onClick={() => navigate("/pricing")} data-testid="trial-reminder-subscribe">Subscribe</Button>
        <button onClick={dismiss} aria-label="Dismiss reminder" className="rounded p-1 opacity-70 transition-opacity hover:opacity-100" data-testid="trial-reminder-dismiss">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
